export enum PublicationStatus {
  DRAFT = 'Draft',
  LIVE = 'Live',
  ARCHIVED = 'Archived',
  DELETED = 'Deleted'
}
